module.exports = __webpack_public_path__ + "static/img/Tiongkok.60b07c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Tiongkok.png
// module id = Bt5X
// module chunks = 1